import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SITE_LIST } from './url-constants';

type SiteSitesEndpointSpecification = ApiEndpointSpecification;
export const SiteSitesEndpointSpecification: SiteSitesEndpointSpecification = {
    url:SITE_LIST,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteSitesRequestParams',
    requestBodySchemaName: 'SiteSitesRequestBody',
    okResponseSchemaName: 'SiteSitesOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteSites = Helpers.makeApiRequestFn<
    Types.SiteSitesRequestParams,
    Types.SiteSitesRequestBody,
    Types.SiteSitesOkResponse
>(SiteSitesEndpointSpecification);
